import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CaseStudiesSection } from '../components/CaseStudiesSection';
import { VideoTestimonialSection } from '../components/VideoTestimonialSection';
import { ServicesSection } from '../components/ServicesSection';
import { MarketingJourneySection } from '../components/MarketingJourneySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { FAQSection } from '../components/FAQSection';
import { Button } from '../components/Button';
export function LandingPage() {
  const scrollToForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-140">
      {/* Navigation - Sticky */}
      <nav className="fixed top-0 left-0 w-full z-50 border-b border-white/10 bg-[#0A1628]/95 backdrop-blur-md" data-id="element-141">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
          <div className="flex items-center justify-between h-24" data-id="element-143">
            <div className="flex items-center" data-id="element-144">
              <img src="https://cdn.magicpatterns.com/uploads/d5Rt2q5xxrBaS9DBEGb4aS/Dealers-Choice-Solutions-Logo-(Dark-Blue-BG).png" alt="DealersChoice Solutions" className="h-16 lg:h-20 w-auto" data-id="element-145" />
            </div>
            <div data-id="element-146">
              <Button variant="primary" className="px-6 py-2.5 text-sm font-semibold" onClick={scrollToForm} data-id="element-147">
                Book A Free Strategy Call
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <main className="flex-grow" data-id="element-148">
        <HeroSection data-id="element-149" />
        <VideoTestimonialSection data-id="element-150" />
        <ServicesSection data-id="element-151" />
        <MarketingJourneySection data-id="element-152" />
        <CaseStudiesSection data-id="element-153" />
        <FinalCTASection data-id="element-154" />
        <FAQSection data-id="element-155" />
      </main>
    </div>;
}